// src/components/AddressModal.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};

const AddressModal = ({
  show,
  onClose,
  address = null,
  customerId,
  onAddressSaved
}) => {
  const isEditMode = !!address;

  const [formData, setFormData] = useState({
   
    phone: '',
    email: '',
    address_line1: '',
    address_line2: '',
    city: '',
    state: '',
    country: '',
    postal_code: '',
    is_default: 0,
    customer_id: customerId || ''
  });

  const [loading, setLoading] = useState(false);

  // Initialize form when address changes (for edit)
  useEffect(() => {
    if (show) {
      if (isEditMode) {
        setFormData({
          first_name: address.first_name || '',
          last_name: address.last_name || '',
          phone: address.phone || '',
          email: address.email || '',
          address_line1: address.address_line1 || '',
          address_line2: address.address_line2 || '',
          city: address.city || '',
          state: address.state || '',
          country: address.country || '',
          postal_code: address.postal_code || '',
          is_default: address.is_default || 0,
          customer_id: address.customer_id || customerId || ''

        });
      } else {
        // For add mode, you can pre-fill from context if needed
        setFormData({
          first_name: '',
          last_name: '',
          phone: '',
          email: '',
          address_line1: '',
          address_line2: '',
          city: '',
          state: '',
          country: '',
          postal_code: '',
          is_default: 0
        });
      }
    }
  }, [show, address, isEditMode]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!customerId) {
      Swal.fire("Error", "Customer ID is missing.", "error");
      return;
    }

    setLoading(true);
    const token = getAuthToken();

    try {
      let res;
      const payload = { ...formData, customer_id: customerId };

      if (isEditMode) {
        // PUT with query params as per your spec
        const params = new URLSearchParams(payload).toString();
        res = await axios.put(
          `https://vantara.datacubeglobal.com/api/delivery-address/${address.address_id}?${params}`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        // POST
        res = await axios.post(
          "https://vantara.datacubeglobal.com/api/delivery-address",
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (res.data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: isEditMode ? "Address updated!" : "Address added!",
          confirmButtonColor: "#7c0046"
        });
        onAddressSaved(); // Notify parent to refresh
        onClose();
      } else {
        throw new Error(res.data.message || "Operation failed");
      }
    } catch (err) {
      console.error("Address save error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Something went wrong.",
        confirmButtonColor: "#7c0046"
      });
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4 border-0 shadow">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold">
              {isEditMode ? "Edit Address" : "Add New Address"}
            </h5>
          <button
  type="button"
  className="btn-close"
  onClick={onClose}
  disabled={loading}
></button>
          </div>
          <div className="modal-body pt-0">
         <form onSubmit={handleSubmit}>
  <div className="row g-3">
    {/* Email & Phone - side by side on ALL screens */}
    <div className="col-6">
      <label className="form-label fw-medium">Email</label>
      <input
        type="email"
        className="form-control"
        name="email"
        value={formData.email}
        onChange={handleChange}
        required
      />
    </div>
    <div className="col-6">
      <label className="form-label fw-medium">Phone</label>
      <input
        type="tel"
        className="form-control"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        required
      />
    </div>

    {/* Address Line 1 & 2 - side by side on ALL screens */}
    <div className="col-12">
      <label className="form-label fw-medium">Address Line 1</label>
      <input
        className="form-control"
        name="address_line1"
        value={formData.address_line1}
        onChange={handleChange}
        required
      />
    </div>
    <div className="col-12 ">
      <label className="form-label fw-medium">Address Line 2 (Optional)</label>
      <input
        className="form-control"
        name="address_line2"
        value={formData.address_line2}
        onChange={handleChange}
      />
    </div>

    {/* City, State, Postal - full width on mobile, 3 columns on medium+ */}
    <div className="col-6">
      <label className="form-label fw-medium">District</label>
      <input
        className="form-control"
        name="city"
        value={formData.city}
        onChange={handleChange}
        required
      />
    </div>
    <div className="col-6">
      <label className="form-label fw-medium">State</label>
      {/* <input
        className="form-control"
        name="state"
        value={formData.state}
        onChange={handleChange}
        required
      /> */}
       <select
  className="form-control"
  value={formData.state}
  onChange={(e) => setFormData(prev => ({ ...prev, state: e.target.value }))}
>
  <option value="">Select State *</option>

  {/* States */}
 <option value="Andhra Pradesh (AP)">Andhra Pradesh (AP)</option>
<option value="Arunachal Pradesh (AR)">Arunachal Pradesh (AR)</option>
<option value="Assam (AS)">Assam (AS)</option>
<option value="Bihar (BR)">Bihar (BR)</option>
<option value="Chhattisgarh (CG)">Chhattisgarh (CG)</option>
<option value="Goa (GA)">Goa (GA)</option>
<option value="Gujarat (GJ)">Gujarat (GJ)</option>
<option value="Haryana (HR)">Haryana (HR)</option>
<option value="Himachal Pradesh (HP)">Himachal Pradesh (HP)</option>
<option value="Jharkhand (JH)">Jharkhand (JH)</option>
<option value="Karnataka (KA)">Karnataka (KA)</option>
<option value="Kerala (KL)">Kerala (KL)</option>
<option value="Madhya Pradesh (MP)">Madhya Pradesh (MP)</option>
<option value="Maharashtra (MH)">Maharashtra (MH)</option>
<option value="Manipur (MN)">Manipur (MN)</option>
<option value="Meghalaya (ML)">Meghalaya (ML)</option>
<option value="Mizoram (MZ)">Mizoram (MZ)</option>
<option value="Nagaland (NL)">Nagaland (NL)</option>
<option value="Odisha (OD)">Odisha (OD)</option>
<option value="Punjab (PB)">Punjab (PB)</option>
<option value="Rajasthan (RJ)">Rajasthan (RJ)</option>
<option value="Sikkim (SK)">Sikkim (SK)</option>
<option value="Tamil Nadu (TN)">Tamil Nadu (TN)</option>
<option value="Telangana (TS)">Telangana (TS)</option>
<option value="Tripura (TR)">Tripura (TR)</option>
<option value="Uttar Pradesh (UP)">Uttar Pradesh (UP)</option>
<option value="Uttarakhand (UK)">Uttarakhand (UK)</option>
<option value="West Bengal (WB)">West Bengal (WB)</option>

<option value="Andaman and Nicobar Islands (AN)">Andaman and Nicobar Islands (AN)</option>
<option value="Chandigarh (CH)">Chandigarh (CH)</option>
<option value="Dadra and Nagar Haveli and Daman and Diu (DN)">
  Dadra and Nagar Haveli and Daman and Diu (DN)
</option>
<option value="Delhi (DL)">Delhi (DL)</option>
<option value="Jammu and Kashmir (JK)">Jammu and Kashmir (JK)</option>
<option value="Ladakh (LA)">Ladakh (LA)</option>
<option value="Lakshadweep (LD)">Lakshadweep (LD)</option>
<option value="Puducherry (PY)">Puducherry (PY)</option>

</select>

    </div>
    <div className="col-6">
      <label className="form-label fw-medium">Postal Code</label>
      <input
        className="form-control"
        name="postal_code"
        value={formData.postal_code}
        onChange={handleChange}
        required
      />
    </div>

    {/* Country - full width always */}
    <div className="col-6">
      <label className="form-label fw-medium">Country</label>
      <input
        className="form-control"
        name="country"
        value={formData.country}
        onChange={handleChange}
        required
      />
    </div>

    {/* Checkbox */}
    <div className="col-12">
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="isDefault"
          name="is_default"
          checked={formData.is_default === 1}
          onChange={handleChange}
        />
        <label className="form-check-label fw-medium" htmlFor="isDefault">
          Set as default shipping address
        </label>
      </div>
    </div>

    {/* Buttons */}
    <div className="col-12 d-flex gap-2 justify-content-end mt-2">
      <button
        type="button"
        className="btn btn-outline-secondary rounded-pill px-4"
        onClick={onClose}
        disabled={loading}
      >
        Cancel
      </button>
      <button
        type="submit"
        className="btn rounded-pill px-4"
        style={{ backgroundColor: "#7c0046", color: "#fff" }}
        disabled={loading}
      >
        {loading ? (
          <span className="spinner-border spinner-border-sm"></span>
        ) : isEditMode ? (
          "Update Address"
        ) : (
          "Add Address"
        )}
      </button>
    </div>
  </div>
</form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressModal;